var map = {
	"./en-au": 1412,
	"./en-au.js": 1412,
	"./en-ca": 1413,
	"./en-ca.js": 1413,
	"./en-gb": 1414,
	"./en-gb.js": 1414,
	"./en-ie": 1415,
	"./en-ie.js": 1415,
	"./en-il": 1416,
	"./en-il.js": 1416,
	"./en-in": 1417,
	"./en-in.js": 1417,
	"./en-nz": 1418,
	"./en-nz.js": 1418,
	"./en-sg": 1419,
	"./en-sg.js": 1419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3143;